
import { useTranslation } from 'react-i18next';
import { PlanLayout } from "@/components/plans/PlanLayout";
import { CheckCircle, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const JigyouKeizokuPage = () => {
  const { t } = useTranslation();

  const benefits = [
    { Icon: Award, title: t('plans_detail.jigyou_keizoku.benefit_0_title'), desc: t('plans_detail.jigyou_keizoku.benefit_0_desc') },
    { Icon: CheckCircle, title: t('plans_detail.jigyou_keizoku.benefit_1_title'), desc: t('plans_detail.jigyou_keizoku.benefit_1_desc') },
    { Icon: CheckCircle, title: t('plans_detail.jigyou_keizoku.benefit_2_title'), desc: t('plans_detail.jigyou_keizoku.benefit_2_desc') },
  ];

  const points = [
    t('plans_detail.jigyou_keizoku.point_0'),
    t('plans_detail.jigyou_keizoku.point_1'),
    t('plans_detail.jigyou_keizoku.point_2'),
    t('plans_detail.jigyou_keizoku.point_3'),
    t('plans_detail.jigyou_keizoku.point_4'),
    t('plans_detail.jigyou_keizoku.point_5'),
  ];

  return (
    <PlanLayout
      title={t('plans_detail.jigyou_keizoku.title')}
      imageUrl="https://images.unsplash.com/photo-1501854140801-50d01698950b"
    >
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 mt-8 text-white">{t('plans_detail.common.overview')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.jigyou_keizoku.overview_p1')}
        </p>
        <p className="mb-8 text-white/70 leading-relaxed">
          {t('plans_detail.jigyou_keizoku.overview_p2')}
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.jigyou_keizoku.benefits_title')}</h2>
        <motion.div
          className="space-y-4 mb-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08 } } }}
        >
          {benefits.map(({ Icon, title, desc }) => (
            <motion.div
              key={title}
              variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } }}
              whileHover={{ scale: 1.02 }}
              className="border border-white/10 bg-white/5 p-6 rounded-xl flex items-start gap-4"
            >
              <Icon className="text-[#d97706] mt-1 h-6 w-6 flex-shrink-0" />
              <div>
                <h3 className="font-bold text-lg mb-2 text-white">{title}</h3>
                <p className="text-white/65 leading-relaxed">{desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.jigyou_keizoku.points_title')}</h2>
        <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70">
          {points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="border border-[#d97706]/30 bg-[#d97706]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#d97706]">{t('plans_detail.common.useful_links')}</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.chusho.meti.go.jp/keiei/antei/bousai/keizokuryoku.htm"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d97706] hover:underline text-sm"
              >
                {t('plans_detail.jigyou_keizoku.link_0_text')}
              </a>
            </li>
            <li>
              <a
                href="https://www.chusho.meti.go.jp/keiei/antei/bousai/download/jigyoukeizokuryoku_shinseisyo.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d97706] hover:underline text-sm"
              >
                {t('plans_detail.jigyou_keizoku.link_1_text')}
              </a>
            </li>
          </ul>
        </div>

        <div className="border border-white/10 bg-white/5 p-6 rounded-xl">
          <h3 className="font-bold text-lg mb-3 text-white">{t('plans_detail.common.contact_title')}</h3>
          <p className="mb-4 text-white/65 leading-relaxed">
            {t('plans_detail.jigyou_keizoku.contact_desc')}
          </p>
          <Button
            className="bg-[#d97706] hover:bg-[#b45309] text-white border-0"
            onClick={() => window.location.href = 'mailto:hori@planjoy.net?subject=事業継続力強化計画について相談したい'}
          >
            {t('plans_detail.jigyou_keizoku.email_button')}
          </Button>
        </div>
      </motion.section>
    </PlanLayout>
  );
};

export default JigyouKeizokuPage;
